import { Construction } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { EmptyState } from '@vnetwork/ui/data';
import { AccountBreadcrumbs } from './components/account-breadcrumbs';

/**
 * Password & Security — stub page. The legacy console shows a "Coming Soon"
 * placeholder for this route; there is no backend for it yet.
 * Mirror: src/pages/account/AccountInfoPage.tsx (shell).
 */
export default function PasswordSecurityPage() {
  return (
    <Container size="full">
      <PageHeader
        breadcrumbs={<AccountBreadcrumbs current="Password & Security" />}
        title="Password & Security"
        description="Manage your password and security settings"
      />
      <EmptyState
        icon={<Construction size={24} />}
        title="Coming soon"
        description="Password and security management is not available yet."
      />
    </Container>
  );
}
